/**
 * @ngdoc config
 * @memberof mercury.startup
 * @name TextAngularConfig
 * @description Config for textAngular to provide an add image option that uses the RecipeImageManage dialog.
 */
angular.module('mercury.startup')
.config(["$provide", function($provide) {
  $provide.decorator('taOptions', ['taRegisterTool', 'taToolFunctions', '$delegate', '$parse', function(taRegisterTool, taToolFunctions, taOptions, $parse) {
    // $delegate is the taOptions we are decorating
    // register the tool with textAngular
    taRegisterTool('addImage', {
      iconclass: 'fa fa-image',
      action: function(promise) {
        var context = this;
        //Get the openNoteImageDialog function from the parent controller.
        var openDialogFunction = $parse('openNoteImageDialog')(context.$editor().$parent);
        var savedSelection = rangy.saveSelection();

        openDialogFunction()
        .then(function(image) {
          rangy.restoreSelection(savedSelection);

          //The data that we embed shouldn't contain the base64 image
          var imageEmbed = angular.copy(image);
          delete imageEmbed.src;

          //The full image element contains the image meta data in a span with the full image inside.
          var imageElement = '<span class="' + encodeURIComponent(JSON.stringify(imageEmbed)) + '"><img src="' + image.src + '"></span>';
          context.$editor().wrapSelection('insertHTML', imageElement);
          promise.resolve();
        });
      },
      onElementSelect: {
        element: 'img',
        action: taToolFunctions.imgOnSelectAction
      }
    });

    return taOptions;
  }]);
}]);
